<template>
	<transition name="new_genre">
		<div class="new_genre">
			<depend-genre v-if="depend"
			@hasDepend="hasDepend"/>
			<button @click="backPage">back</button>
			<p>{{name}}</p>
			<div class="container">
				<div class="table">
					<div class="wrap_options">
						<label for="order">ID</label>
						<input type="text"
						       id="order"
						       disabled
						       @focus="error = false"
						       :value="id">
					</div>
					<div class="wrap_options">
						<label for="name">название</label>
						<input type="text"
						       id="name"
						       @focus="error = false"
						       :value="obj.name">
					</div>
					<div class="wrap_options">
						<label for="display_name">отображаемое название</label>
						<input type="text"
						       id="display_name"
						       @focus="error = false"
						       :value="obj.display_name">
					</div>
				</div>
			</div>
			
			<button @click="change"
			        v-if="idDisabled">save
			</button>
			<button @click="save"
			        v-if="!idDisabled">save
			</button>
			<button @click="deleteGenre"
			        v-if="idDisabled">delete
			</button>
			<transition name="error">
				<p id="error"
				   v-if="error">все поля должны быть заполнены!!!</p>
			</transition>
		</div>
	</transition>
</template>
<script>
	import { performRequest }                   from "../script/ws/wsclient";
	import { mapGetters, mapState, mapActions } from "vuex";
	import DependGenre                               from "./DependGenre";

	export default {
		name:     "NewGenre",
		components: { DependGenre },
		data() {
			return {
				name:       "",
				idDisabled: false,
				id:         0,
				obj:        {},
				error:      false,
				old_name:   "",
				depend: false
			};
		},
		beforeMount() {
			if (this.$route.path === "/edit_genre") {
				this.name       =
					"редактирование жанра с ID: " +
					this.getSelectedGenre.item.order_no;
				this.idDisabled = true;
				this.id         = this.getSelectedGenre.item.order_no;
				this.obj        = this.getSelectedGenre.item;
				this.old_name   = this.getSelectedGenre.item.name;
				console.log(this.old_name);
			} else if (this.$route.path === "/new_genre") {
				this.name       = "создание нового жанра";
				this.idDisabled = false;
				this.obj        = {
					name:         "",
					display_name: ""
				};
				this.getGenre.forEach(item => {
					if (this.id < item.order_no) {
						this.id = item.order_no;
					}
				});
				this.id += 1;
			}
		},
		methods:  {
			...mapActions(["setGenre"]),
			backPage() {
				this.$router.go(-1);
			},
			hasDepend() {
				this.depend = false
			},
			save() {
				if (
					document.querySelector("#order").value !== "" &&
					document.querySelector("#name").value !== "" &&
					document.querySelector("#display_name").value !== ""
				) {
					// this.getGenre.push({
					// 	order_no:     +document.querySelector("#order").value,
					// 	name:         document.querySelector("#name").value,
					// 	display_name: document.querySelector("#display_name").value
					// });
					performRequest(
						{
							section: "tvcontent.genre",
							name:    "createGenre"
						},
						{
							order_no:     +document.querySelector("#order").value,
							name:         document.querySelector("#name").value,
							display_name: document.querySelector("#display_name").value,
							operator: this.getViewUser
						},
						a => {
							if (a.code === 200) {
								performRequest(
									{
										section: "tvcontent.genre",
										name:    "getGenreList"
									},
									{
										operator: this.getViewUser
									},
									a => {
										if (a.code === 200) {
											this.setGenre();
										} else {
											console.log("ошибка при получении жанров");
										}

									}
								);
							} else {
								console.log("ошибка при создании жанров");
							}

						});
					this.$router.go(-1);
				} else {
					this.error = true;
				}
			},
			change() {
				if (
					document.querySelector("#order").value !== "" &&
					document.querySelector("#name").value !== "" &&
					document.querySelector("#display_name").value !== ""
				) {
					this.getGenre.forEach(elem => {
						if (elem.order_no === this.getSelectedGenre.item.order_no) {
							elem.name         = document.querySelector("#name").value;
							elem.display_name = document.querySelector("#display_name").value;
							performRequest(
								{
									section: "tvcontent.genre",
									name:    "updateGenre"
								},
								{
									order_no:     elem.order_no,
									name:         elem.name,
									display_name: elem.display_name,
									old_name:     this.old_name,
									operator: this.getViewUser
								},
								a => {
									if (a.code === 200) {
										this.setGenre();
									} else {
										this.setGenre();
										console.log("ошибка при редактировании жанров");
									}

								});
						}
					});
					this.$router.go(-1);
				} else {
					this.error = true;
				}
			},
			deleteGenre() {
				this.getGenre.forEach(elem => {
					if (elem.order_no === this.getSelectedGenre.item.order_no) {
						performRequest(
							{
								section: "tvcontent.genre",
								name:    "deleteGenre"
							},
							{
								name: elem.name,
								operator: this.getViewUser
							},
							a => {
								if (a.code === 200) {
									this.setGenre();
									this.$router.go(-1);
								} else if (a.code === 409) {
									this.depend = true;
								}
								else {
									console.log("ошибка при редактировании жанров");
								}

							});
					}
				});
				
			}
		},
		computed: {
			...mapGetters([
				"getSelectedGenre",
				"getGenre",
				"getViewUser"
			]),
			...mapState([
				"selectedGenre"
			])
		}
	};
</script>
<style scoped lang="scss">
	.new_genre {
		background-color: rgba(238, 238, 200, 0.8);
		box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.4), 1px 1px 5px #333;
		/*padding: 0.5rem 0.5rem 1rem 0.5rem;*/
		height: calc(100vh - 5rem);
		overflow: auto;
		position: absolute;
		margin-top: 4rem;
		width: 90%;
		right: 50%;
		transform: translateX(50%);
		flex-direction: column;
		p#error {
			display: inline-block;
			font-size: 1.1rem;
			color: red;
			float: none;
		}
		button {
			background: #bbf291;
			border-radius: 0.2rem;
			line-height: 1.8rem;
			border: none;
			outline: none;
			height: 2.5rem;
			padding: 0.2rem 1rem;
			transition: all 0.2s;
			cursor: pointer;
			margin: 1rem;
			
			&:hover {
				background: #78956b;
				color: white;
				
				&:active {
					box-shadow: 0 0 1rem #967068;
				}
			}
		}
		
		.container {
			clear: both;
			margin: 0.5rem 0.5rem 0.5rem 50%;
			width: 90%;
			transform: translateX(-50%);
			.table {
				width: 100%;
				transition: all .3s;
				
				.wrap_options {
					width: 100%;
					display: flex;
					justify-content: space-between;
					flex-wrap: wrap;
					margin: 0.5rem;
					
					input[type='text'] {
						min-width: 20rem;
						border-radius: 3px;
						outline: none;
						border: 1px solid #c9c9c9;
						padding-left: 5px;
						flex-grow: 1;
						margin-bottom: 5px;
						&:focus {
							box-shadow: 0 0 5px #69bf8f;
						}
					}
					
					label {
						width: 20rem;
					}
				}
			}
		}
		
		p {
			float: right;
			margin: 0.5rem;
			padding-right: 3%;
			.bold {
				font-weight: bold;
			}
		}
	}
	@media (max-width: 620px) {
		.new_genre {
			min-height: calc(100vh - 9rem);
			height: auto;
			min-width: 30rem;
			margin-top: 8rem;
		}
	}
	.new_genre-enter-active {
		transition: all 0.5s ease;
	}
	.new_genre-leave-active {
		transition: all 0.5s ease;
	}
	.new_genre-enter, .new_genre-leave-to {
		opacity: 0;
	}
	.error-enter-active {
		transition: all 0.5s ease;
	}
	.error-leave-active {
		transition: all 0.5s ease;
	}
	.error-enter, .error-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/NewGenre.vue